import type { CollectorProgress } from '@/types/progress';
import type { PricingRange } from '@/hooks/use-pricing-ranges';
import type {
  BarSegment,
  BarStripe,
} from '@/components/ui/stacked-progress-bar';
import { getCollectorColor } from '@/utils/collector-colors';
import { formatFollowers } from '@/utils/formatters';
import { memberDisplay, type ViewerContext } from '@/utils/member-display';

export const WEEKLY_STRIPES: BarStripe[] = [
  { position: 0.333, variant: 'symbolic' },
  { position: 0.666, variant: 'symbolic' },
];

function segmentLabel(c: CollectorProgress, viewer: ViewerContext): string {
  const { id, first_name, last_name, photo } = c;
  const display = memberDisplay({ id, first_name, last_name, photo }, viewer);
  return display.fullName ?? display.name;
}

export function toSegments(
  collectors: CollectorProgress[],
  colors: Record<string, string>,
  viewer: ViewerContext
): BarSegment[] {
  return collectors.map((c) => ({
    id: c.id,
    label: segmentLabel(c, viewer),
    value: c.count,
    color: getCollectorColor(colors, c.id),
    photo: c.photo,
    role: c.role,
  }));
}

export function rangeMilestones(
  ranges: PricingRange[],
  totalGoal: number
): BarStripe[] {
  return ranges
    .filter((r) => r.range_min > 0 && r.range_min <= totalGoal)
    .map((r) => ({
      position: r.range_min / totalGoal,
      variant: 'milestone' as const,
      label: formatFollowers(r.range_min),
    }));
}
